import UpAppLogo from '@/assets/logos/upseat_logo.svg'
import { apiClient } from '@/services/axios'
import { motion } from 'framer-motion'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

const RedirectEngine = () => {
  const { shortcode } = useParams()
  const navigate = useNavigate()
  const [error, setError] = useState(false)

  useEffect(() => {
    if (!shortcode) return
    apiClient
      .get(`/upauth/shorturl?code=${shortcode}`)
      .then((res) => {
        if (res.data.error) {
          setError(true)
          return
        }
        let url = res.data
        try {
          const parsed = new URL(url)
          url = parsed.pathname + parsed.search + parsed.hash
        } catch {
          if (url && !url.startsWith('/')) {
            url = '/' + url
          }
        }
        if (url) {
          navigate(url, { replace: true })
        } else {
          setError(true)
        }
      })
      .catch(() => {
        setError(true)
      })
  }, [shortcode, navigate])

  if (error) {
    return (
      <motion.div
        initial={{ opacity: 0.01 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="flex flex-col items-center justify-center h-[100dvh] w-full"
      >
        <div className="max-w-md text-center p-6 bg-grey4">
          <h2 className="text-xl font-semibold mb-4 text-red2">
            Ticket Not Found
          </h2>
          <p className="mb-4 text-grey5">
            Sorry, we weren't able to load your ticket.
            <br />
            Please contact our support team for help.
          </p>
          <a
            href="mailto:help@upapp.uk"
            className="inline-block px-4 py-2 bg-blue rounded text-white transition underline"
          >
            help@upapp.uk
          </a>
        </div>
      </motion.div>
    )
  }

  return (
    <motion.div
      initial={{ opacity: 0.01 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      exit={{ opacity: 0.01 }}
      className="w-full flex flex-col gap-4 items-center justify-center h-[100dvh] text-lg"
    >
      <img src={UpAppLogo} alt="up-logo" className={`w-[8vw]`} />
      <p className="font-headline capitalize">{`redirecting...`}</p>
    </motion.div>
  )
}

export default RedirectEngine
